import { render } from "./UpdateVideoModal.vue?vue&type=template&id=c4247054"
import script from "./UpdateVideoModal.vue?vue&type=script&lang=js"
export * from "./UpdateVideoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__